// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DrsX","clinicsSelect":"styles_clinicsSelect__3yHMB"};